module.exports = "/_next/static/images/mixvegetables-d373d841bd69a379a79e438c982a2844.jpg";